var _rect, _circle, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270 270",
    role: "img",
    "aria-label": "Staff photo coming soon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 270,
    fill: "#505050"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 96,
    r: 42,
    fill: "#FCF6E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCF6E4",
    d: "M54 230c8-48 38-74 81-74s73 26 81 74v12H54z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 252,
    textAnchor: "middle",
    fill: "#FCF6E4",
    fontFamily: "Trebuchet MS, Arial, sans-serif",
    fontSize: 16
  }, "photo soon")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.6b124d148c3c184f1db59cea3f42fac1.svg";
export { ForwardRef as ReactComponent };